function hasGetUserMedia() {
    return !!(navigator.mediaDevices &&
        navigator.mediaDevices.getUserMedia);
}

if ($("#_fileUpload").length > 0) {
    var oper = !window.oper ? "operid" : window.oper;
    console.log('_fileUpload detected');

    if (hasGetUserMedia() && "ontouchstart" in document.documentElement === true) {
        // show camera button
        $(".btnCamera").show();
    }

    $("#_fileUpload .btnUpload").prop('disabled', true);

    $(document).on('change', "#_uploadDocTypes", function () {
        console.log($(this).val());
        if ($(this).val() == '') {
            $("#_fileUpload .btnUpload").prop('disabled', true).attr('disabled', 'disabled');
        } else {
            $("#_fileUpload .btnUpload").removeProp('disabled').removeAttr('disabled');
        }
    });

    var FileId;
    var SourceId;

    $(document).on('click', '.btnDel', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        var self = $(this);

        //Set the global file and source id fields
        FileId = self.data('id');
        SourceId = self.data('sourceid');

        //Display the Delete Model window       
        $("#fileDeleteModal").modal();
    });

    //Respond to the button delete file click event    
    $(document).on('click', '#btnDeleteUploadYes', function (e) {
        var url = '';
        var self = $(this);

        if (location.href.indexOf('/en/') > 0) {
            url = location.href.split('/en/')[0] + '/en/wageenhancement/employee/DeleteEmployeeFile/' + oper + '/';
        } else {
            url = location.href.split('/fr/')[0] + '/fr/wageenhancement/employee/DeleteEmployeeFile/' + oper + '/';
        }

        $.ajax({
            url: url + '?FileId=' + FileId + '&SourceId=' + SourceId,
            method: 'POST',
            contentType: false,
            processData: false,
            success: function (res) {
                url = url.replace('DeleteEmployeeFile', 'GetEmployeeFileListPartial') + '?id=' + $("#_fileUpload").data('sourceid') + '&allowDelete=' + $("#_fileUpload").data('d') + '&allowDeleteNew=' + $("#_fileUpload").data('dn') + '&allowNew=' + $("#_fileUpload").data('n') + '&allowEdit=' + $("#_fileUpload").data('e') + '&applicationId=' + $("#_fileUpload").data('applicationid') + '&isfundingupgrade=' + $("#_fileUpload").data('isfundingupgrade') + '&isavailableonnewapplications=' + $("#_fileUpload").data('isavailableonnewapplications') + '&isavailableonupgradefundingapplications=' + $("#_fileUpload").data('isavailableonupgradefundingapplications') + '&perm=' + $("#_fileUpload").data('perm') ;
                $("#_fileUploadCont").load(url, function () {
                    $("#_fileUpload .btnUpload").prop('disabled', true);
                    $("#fileModal").modal();
                });
            },
            error: function () {
                url = url.replace('DeleteEmployeeFile', 'GetEmployeeFileListPartial') + '?id=' + $("#_fileUpload").data('sourceid') + '&allowDelete=' + $("#_fileUpload").data('d') + '&allowDeleteNew=' + $("#_fileUpload").data('dn') + '&allowNew=' + $("#_fileUpload").data('n') + '&allowEdit=' + $("#_fileUpload").data('e') + '&applicationId=' + $("#_fileUpload").data('applicationid') + '&isfundingupgrade=' + $("#_fileUpload").data('isfundingupgrade') + '&isavailableonnewapplications=' + $("#_fileUpload").data('isavailableonnewapplications') + '&isavailableonupgradefundingapplications=' + $("#_fileUpload").data('isavailableonupgradefundingapplications') + '&perm=' + $("#_fileUpload").data('perm');
                $("#_fileUploadCont").load(url, function () {
                    $("#_fileUpload .btnUpload").prop('disabled', true);
                    $("#fileModal").modal();
                });
            }
        });
    });

    $(document).on('change', "#_fileUpload input:file", function () {
        var fileName = $(this).val();
        console.log(fileName); //Do with the filename whatever you want

        if (!fileName) {
            return;
        }
        
        var formData = new FormData();
        var d = $(this)[0].files[0];

        formData.append('File', d);
        formData.append('SourceId', $(this).data('sourceid'));
        formData.append('DocTypeId', $("#_uploadDocTypes").val());

        //console.log('applicationid=' + $("#_fileUpload").data('applicationid'));
        // optionally append the application id
        if ($("#_fileUpload").data('applicationid') && !$("#_fileUpload").data('ignoreappid')) {
            formData.append('ApplicationId', $("#_fileUpload").data('applicationid'));
            //console.log("hhh"); console.log($("#_fileUpload").data('ignoreappid'));
        }


        var url = '';
        if (location.href.indexOf('/en/') > 0) {
            url = location.href.split('/en/')[0] + '/en/wageenhancement/employee/UploadEmployeeFile/' + oper + '/';
        } else {
            url = location.href.split('/fr/')[0] + '/fr/wageenhancement/employee/UploadEmployeeFile/' + oper + '/';
        }

        $("#_fileUpload .btnUpload").find('i.fa-file-upload').removeClass('fa-file-upload').addClass('fa-spinner fa-spin');
        $("#_fileUpload .btnUpload").prop('disabled', true).attr('disabled', 'disabled');
        $("#divFileUploadSpinner").removeClass("d-none");
        
        $.ajax({
            url: url,
            method: 'POST',
            contentType: false,
            processData: false,
            data: formData,
            success: function (res) {

                url = url.replace('UploadEmployeeFile', 'GetEmployeeFileListPartial') + '?id=' + $("#_fileUpload").data('sourceid') + '&allowDelete=' + $("#_fileUpload").data('d') + '&allowDeleteNew=' + $("#_fileUpload").data('dn') + '&allowNew=' + $("#_fileUpload").data('n') + '&allowEdit=' + $("#_fileUpload").data('e') + '&applicationId=' + $("#_fileUpload").data('applicationid') + '&isfundingupgrade=' + $("#_fileUpload").data('isfundingupgrade') + '&isavailableonnewapplications=' + $("#_fileUpload").data('isavailableonnewapplications') + '&isavailableonupgradefundingapplications=' + $("#_fileUpload").data('isavailableonupgradefundingapplications') + '&getallfiles=' + $("#_fileUpload").data('getallfiles') + '&perm=' + $("#_fileUpload").data('perm');

                // Hide any errors that exist on the page
                $(".file-error-alert").addClass("d-none");

                $("#_fileUploadCont").load(url, function () {
                    $("#_fileUpload .btnUpload").prop('disabled', true);
                    $("#divFileUploadSpinner").addClass("d-none");
                    $("#fileModal").modal();
                });
            },
            error: function () {
                url = url.replace('UploadEmployeeFile', 'GetEmployeeFileListPartial') + '?id=' + $("#_fileUpload").data('sourceid') + '&allowDelete=' + $("#_fileUpload").data('d') + '&allowDeleteNew=' + $("#_fileUpload").data('dn') + '&allowNew=' + $("#_fileUpload").data('n') + '&allowEdit=' + $("#_fileUpload").data('e') + '&applicationId=' + $("#_fileUpload").data('applicationid') + '&isfundingupgrade=' + $("#_fileUpload").data('isfundingupgrade') + '&isavailableonnewapplications=' + $("#_fileUpload").data('isavailableonnewapplications') + '&isavailableonupgradefundingapplications=' + $("#_fileUpload").data('isavailableonupgradefundingapplications') + '&getallfiles=' + $("#_fileUpload").data('getallfiles') + '&perm=' + $("#_fileUpload").data('perm');

                // Hide any errors that exist on the page
                $(".file-error-alert").addClass("d-none");

                $("#_fileUploadCont").load(url, function () {
                    $("#_fileUpload .btnUpload").prop('disabled', true);
                    $("#divFileUploadSpinner").addClass("d-none");
                    $("#fileModal").modal();
                });
            }
        });


    });

    //Respond to the button delete file click event    
    function refreshFileList() {
        var url = '';
        var self = $(this);

        if (location.href.indexOf('/en/') > 0) {
            url = location.href.split('/en/')[0] + '/en/wageenhancement/employee/GetEmployeeFileListPartial/' + oper + '/';
        } else {
            url = location.href.split('/fr/')[0] + '/fr/wageenhancement/employee/GetEmployeeFileListPartial/' + oper + '/';
        }

        //Add the parameters to the URL
        url = url + '?id=' + $("#_fileUpload").data('sourceid') + '&allowDelete=' + $("#_fileUpload").data('d') + '&allowDeleteNew=' + $("#_fileUpload").data('dn') + '&allowNew=' + $("#_fileUpload").data('n') + '&allowEdit=' + $("#_fileUpload").data('e') + '&applicationId=' + $("#_fileUpload").data('applicationid') + '&isfundingupgrade=' + $("#_fileUpload").data('isfundingupgrade') + '&isavailableonnewapplications=' + $("#_fileUpload").data('isavailableonnewapplications') + '&isavailableonupgradefundingapplications=' + $("#_fileUpload").data('isavailableonupgradefundingapplications') + '&perm=' + $("#_fileUpload").data('perm');
        $("#_fileUploadCont").load(url, function () {
        });
    };
}